<template>
  <div class="collection-info-section" :class="{'--open': isOpen}">
    <div class="collection-info-section__head collection-questions__head" @click="changeOpen">
      <span class="h5 semibold">{{ label }}</span>
      <div class="collection-questions__info">
        <span class="--count">{{questionsCount}}</span>
      </div>
      <img class="--arrow" src="~/assets/img/svg/common/arrow-down.svg" alt=""/>
    </div>
    <div class="collection-info-section__body collection-questions__body">
      <button class="collection-questions__button btn btn-primary" @click="openCreateQuestion">
        Задать вопрос
      </button>
      <template
        v-for="(item, index) in questions"
        :key="`questions-${index}`"
      >
        <QuestionCardSmall
          :item="item"
        />
        <div
          v-if="index !== questions.length - 1"
          class="collection-questions__body-separator"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useNuxtApp} from "nuxt/app";
import QuestionCardSmall from "~/components/questions/QuestionCardSmall.vue";
import {computed} from "vue";
import {useCreateQuestionModal} from "~/composables/useCreateQuestionModal";

const props = defineProps({
  product: {
    type: Object as any,
    default: () => {}
  },
  model: {
    type: String,
  },
  page: {
    type: String,
  },
});

const {
  $api,
  $caseWords,
  $numberFormat,
} = useNuxtApp();
const {
  openCreateQuestionModal
} = useCreateQuestionModal()

const questionsCount = computed(() => {
  const count = Number.parseFloat(props?.product?.questionsCount || questions.value.length || 0);
  const word = $caseWords(count, ['вопрос','вопроса','вопросов'])
  return [count, word].join(" ")
});
const label = computed(() => {
  return Boolean(props.page === 'Product') ? 'Вопросы о товаре' : 'Вопросы о коллекции'
});
// Логика открытия
const isOpen = ref(false);
const changeOpen = () => {
  isOpen.value = !isOpen.value;
};
//получение вопросов, берется из ревью по type: question
const questions: any = ref([])
const getQuestions = async () => {
  if (!props.product?.id) return
  const res = await $api.agent.get(`/reviews?filter[model]=${props.model}&filter[model_key]=${props.product.id}&filter[type]=question&expand=files`)
    .then((res) => {
      return res._data
    })
    .catch(() => {
      return []
    });
  questions.value = res;
}

const openCreateQuestion = () => {
  openCreateQuestionModal(props.product);
}

useJsonld(() => {
  const mainEntity = questions.value.map((item: any, index: number) => {
    const answer = item?.children?.[0];
    return {
      "@type": "Question",
      "name": item.text || item.name_value || item.name,
      "acceptedAnswer": {
        "@type": "Answer",
        "@id": `a${index + 1}`,
        "text": answer?.text || ""
      }
    };
  }).filter((item: any) => item.acceptedAnswer.text);

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": mainEntity
  };
});

onMounted(async () => {
  await getQuestions();
});
getQuestions();
</script>

<style scoped lang="scss">
.collection-questions__head {
  justify-content: initial;

  .--arrow {
    margin-left: auto;
  }
}
.collection-questions__info {
  display: flex;
  align-items: center;
  margin-left: auto;
  color: #989898;
  font-size: 12px;
  font-weight: 500;
  line-height: 100%;

  img {
    width: 13px;
    height: 13px;
    margin-right: 6px;
    transform: initial!important;
  }

  .--count {
    margin-left: 8px;
    margin-bottom: -2px;
    border-bottom: 1px solid;
    color: rgb(152 152 152 / 100%);

    &:hover {
      border-bottom: 1px solid transparent;
    }
  }
}
.collection-questions__button {
  width: 100%;
  height: 60px;
  margin-bottom: 24px;
  border-radius: 16px;
  text-align: center;
  font-weight: 600;
}

.review-card {
  padding: 24px 0;
  box-sizing: border-box;
  border-top: 1px solid #EBEBEB;
}
.review-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .--name {
    color: #000000;
  }
}
.review-card__body {
  margin-top: 16px;
  color: #989898;
}
.collection-questions__body-separator {
  margin-bottom: 16px;
  width: 100%;
  height: 1px;
  background-color: #F4F3F1;
}

@media (max-width: 1023px) {
  .collection-reviews__button {
    height: 48px;
    border-radius: 12px;
  }
}
</style>
